var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkedDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F9F0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22193_80750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 8.00098H24.833V24.001H8.83301V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22193_80750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9515 12.0135C23.0586 12.1206 23.1193 12.2653 23.1193 12.417V23.4296C23.1193 23.7456 22.864 24.001 22.5479 24.001H11.1193C10.8032 24.001 10.5479 23.7456 10.5479 23.4296V8.57241C10.5479 8.25633 10.8032 8.00098 11.1193 8.00098H18.7032C18.855 8.00098 19.0014 8.06169 19.1086 8.16883L22.9515 12.0135ZM21.8015 12.6795L18.4407 9.31884V12.6795H21.8015ZM13.405 15.4653C13.3655 15.4653 13.3319 15.4792 13.304 15.5071C13.2761 15.535 13.2621 15.5687 13.2621 15.6081V16.4653C13.2621 16.5047 13.2761 16.5384 13.304 16.5663C13.3319 16.5942 13.3655 16.6081 13.405 16.6081H20.2621C20.3016 16.6081 20.3353 16.5942 20.3632 16.5663C20.391 16.5384 20.405 16.5047 20.405 16.4653V15.6081C20.405 15.5687 20.3911 15.535 20.3632 15.5071C20.3353 15.4792 20.3016 15.4653 20.2621 15.4653H13.405ZM13.405 17.8938C13.3655 17.8938 13.3319 17.9078 13.304 17.9357C13.2761 17.9636 13.2621 17.9972 13.2621 18.0367V18.8939C13.2621 18.9333 13.2761 18.967 13.304 18.9949C13.3319 19.0228 13.3655 19.0367 13.405 19.0367H16.6907C16.7302 19.0367 16.7638 19.0228 16.7917 18.9949C16.8196 18.967 16.8336 18.9333 16.8336 18.8939V18.0367C16.8336 17.9972 16.8196 17.9636 16.7917 17.9357C16.7638 17.9078 16.7302 17.8938 16.6907 17.8938H13.405Z",
    fill: "#722ED1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkedDataIcon);
export default __webpack_public_path__ + "static/media/workedDataIcon.bd731b5d80f4fc4544bc13691234f2d5.svg";
export { ForwardRef as ReactComponent };